import React from 'react';

interface IconProps {
  fill: string;
  height: string;
  width: string;
}

function CRMIcon({ fill, height, width }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 39 35">
      <path
        fill={fill}
        d="M28.185 14.412a1.985 1.985 0 01-2.782 0l-8.696-8.677L2.99 19.43l-1.284-1.226a5.836 5.836 0 010-8.248l8.25-8.25a5.836 5.836 0 018.248 0l9.98 9.962a1.938 1.938 0 010 2.743zm1.362-4.125a3.898 3.898 0 010 5.506c-2.47 2.47-5.078.428-5.506 0l-7.315-7.315L5.89 19.314a1.938 1.938 0 000 2.744 1.961 1.961 0 002.763 0l8.988-8.989 1.381 1.382-8.988 8.988a1.937 1.937 0 000 2.743 1.96 1.96 0 002.762 0l8.989-8.988 1.381 1.381-8.988 8.988a1.938 1.938 0 000 2.744 1.938 1.938 0 002.743 0l8.988-8.989L27.29 22.7l-8.988 8.988a1.937 1.937 0 000 2.743 1.937 1.937 0 002.743 0l16.187-16.225a5.836 5.836 0 000-8.25l-8.249-8.248C26.746-.53 23.127-.57 20.851 1.59l8.696 8.696z"
      ></path>
    </svg>
  );
}

export default CRMIcon;
